import { render } from "./AlertInfo.vue?vue&type=template&id=bb99bf8c&scoped=true&ts=true"
import script from "./AlertInfo.vue?vue&type=script&lang=ts"
export * from "./AlertInfo.vue?vue&type=script&lang=ts"

import "./AlertInfo.vue?vue&type=style&index=0&id=bb99bf8c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb99bf8c"]])

export default __exports__